// СГЕНЕРИРОВАНО: node packages/ui-tokens/generate.mjs — руками не править.
// Источник истины — palette.mjs в oklch, из design/README.md.

export interface ColorToken {
  /** Для веба и CSS — как задано дизайном. */
  oklch: string
  /**
   * Для React Native — честный пересчёт в sRGB.
   *
   * У полупрозрачных токенов последняя пара — альфа, округлённая до 1/255.
   * Композит из неё расходится с веб-версией на единицу канала: браузер
   * смешивает по точной доле из oklch. Разница невидима, но если считать
   * наложение самим, долю берите из palette.mjs, а не отсюда.
   */
  hex: string
  usage: string
}

export const COLORS = {
  bg: { oklch: 'oklch(0.98 0.004 255)', hex: '#f7f9fb', usage: 'фон экрана' },
  surface: { oklch: 'oklch(1 0 0)', hex: '#ffffff', usage: 'карточки, шиты, поля ввода' },
  'surface-alt': { oklch: 'oklch(0.975 0.005 255)', hex: '#f4f7fa', usage: 'невыбранные чипы, вложенные блоки' },
  ink: { oklch: 'oklch(0.22 0.025 258)', hex: '#131b26', usage: 'основной текст, тёмные кнопки, пузырь пользователя' },
  'ink-70': { oklch: 'oklch(0.32 0.025 258)', hex: '#2b3340', usage: 'текст на чипах' },
  'ink-55': { oklch: 'oklch(0.42 0.02 258)', hex: '#464e58', usage: 'вторичный текст' },
  'ink-45': { oklch: 'oklch(0.48 0.02 258)', hex: '#575e69', usage: 'подписи, мета' },
  'ink-40': { oklch: 'oklch(0.5 0.02 258)', hex: '#5c646f', usage: 'мета мельче 13px' },
  'ink-30': { oklch: 'oklch(0.54 0.02 258)', hex: '#686f7b', usage: 'плейсхолдеры' },
  'ink-20': { oklch: 'oklch(0.66 0.02 258)', hex: '#8b939f', usage: 'шевроны' },
  accent: { oklch: 'oklch(0.52 0.17 258)', hex: '#1c65c8', usage: 'кобальт: обводки, прогресс, активный чип, отправка' },
  'accent-text': { oklch: 'oklch(0.38 0.15 258)', hex: '#003d90', usage: 'текст акцентом на светлой подложке' },
  'accent-link': { oklch: 'oklch(0.42 0.16 258)', hex: '#0047a2', usage: 'ссылки-действия' },
  'accent-soft': { oklch: 'oklch(0.52 0.17 258 / 0.13)', hex: '#1c65c821', usage: 'подложка бейджей остатка, тег «ПЛЮС»' },
  'accent-tint': { oklch: 'oklch(0.93 0.025 258)', hex: '#dee9f9', usage: 'светлая подложка' },
  line: { oklch: 'oklch(0.92 0.008 255)', hex: '#e1e5ea', usage: 'границы карточек' },
  'line-soft': { oklch: 'oklch(0.95 0.008 255)', hex: '#ebeff4', usage: 'разделители внутри карточек' },
  'line-strong': { oklch: 'oklch(0.9 0.008 255)', hex: '#dadee3', usage: 'границы полей ввода' },
  'status-ok': { oklch: 'oklch(0.6 0.11 150)', hex: '#4a925c', usage: '«подтверждено», выполненные этапы' },
  'status-ok-text': { oklch: 'oklch(0.4 0.09 150)', hex: '#1b552c', usage: 'подпись под «подтверждено»' },
  'status-ok-soft': { oklch: 'oklch(0.6 0.11 150 / 0.16)', hex: '#4a925c29', usage: 'фон бейджа' },
  'status-warn': { oklch: 'oklch(0.7 0.12 70)', hex: '#ce9042', usage: '«спорно», средний риск' },
  'status-warn-soft': { oklch: 'oklch(0.7 0.12 70 / 0.18)', hex: '#ce90422e', usage: 'фон бейджа «спорно»' },
  'status-warn-text': { oklch: 'oklch(0.48 0.1 70)', hex: '#81520a', usage: 'подпись' },
  'status-none': { oklch: 'oklch(0.78 0.012 258)', hex: '#b3b8bf', usage: '«не найдено»' },
  'status-danger': { oklch: 'oklch(0.58 0.16 25)', hex: '#c74b47', usage: 'высокий риск' },
  'danger-text': { oklch: 'oklch(0.55 0.14 25)', hex: '#b54a46', usage: '«удалить аккаунт», «отменить»' },
  'row-hover': { oklch: 'oklch(0.965 0.006 255)', hex: '#f1f4f7', usage: 'наведение на строку списка или таблицы (веб)' },
  'ink-hover': { oklch: 'oklch(0.28 0.03 258)', hex: '#202938', usage: 'наведение на тёмную кнопку (веб)' },
  'accent-hover': { oklch: 'oklch(0.46 0.17 258)', hex: '#0052b4', usage: 'наведение на кобальтовую кнопку (веб)' },
  'accent-active': { oklch: 'oklch(0.52 0.17 258 / 0.1)', hex: '#1c65c81a', usage: 'активная строка левой колонки, тень выделенной карточки (веб)' },
  scrim: { oklch: 'oklch(0.22 0.025 258 / 0.4)', hex: '#131b2666', usage: 'затемнение под модальным окном подтверждения (веб)' },
} as const satisfies Record<string, ColorToken>

export type ColorName = keyof typeof COLORS

/** Цвет для React Native. */
export const hex = (name: ColorName): string => COLORS[name].hex

/** Цвет для веба — oklch точнее, браузеры его понимают. */
export const css = (name: ColorName): string => COLORS[name].oklch
